import { css } from '@emotion/react'
import { colors, font } from 'plume-ui'
import { useRef, useState } from 'react'
import { IcomoonIcon } from '../../../../atoms/IcomoonIcon'

import { CompanyFirstInterviewDateCalender } from '../../../companies/components/company-firstInterview-date-calender'
import { useOnClickOutside } from '../../../../../hooks/useOnClickOutside'
import { User } from '../../../../../types'
import { useUser } from '../../../../../contexts/AuthContext'
import { SUM_OF_FIRST_INTERVIEW_DATE_SETTING, trackEvent } from '@/lib/tracking'
import { StatusPanelSection } from './StatusPanelSection'

type Props = {
  shortName: string
  selectedFirstInterviewDate?: string
  setSelectedFirstInterviewDate: (
    firstInterviewDate: string | undefined
  ) => void
  onSelectFirstInterviewDate: (
    companyId: string,
    firstInterviewDate: string,
    user: User
  ) => void
  onSelectFirstInterviewDateBlank: (companyId: string, user: User) => void
}

export const FirstInterviewDateSection: React.FC<Props> = ({
  shortName,
  selectedFirstInterviewDate,
  setSelectedFirstInterviewDate,
  onSelectFirstInterviewDate,
  onSelectFirstInterviewDateBlank,
}) => {
  const currentUser = useUser()
  const [calendarOpening, setCalendarOpening] = useState(false)

  const firstInterviewDateRef = useRef<HTMLDivElement>(null)
  useOnClickOutside([firstInterviewDateRef], () => {
    setCalendarOpening(false)
  })

  return (
    <StatusPanelSection label="初回面談日">
      <div
        css={css`
          position: relative;
        `}
        ref={firstInterviewDateRef}
      >
        <button
          css={css`
            display: flex;
            border: none;
            align-items: center;
            padding: 7px 4px 7px 10px;
            gap: 4px;
            border-radius: 3px;
            cursor: pointer;
            background-color: ${calendarOpening
              ? colors.gray40
              : 'transparent'};
            &:hover {
              background-color: ${colors.gray40};
            }
            position: relative;
          `}
          onClick={() => setCalendarOpening(true)}
        >
          <div
            css={css`
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: ${font.weight.normal};
              font-size: 14px;
              color: ${selectedFirstInterviewDate
                ? `${colors.black30}`
                : `${colors.gray70}`};
            `}
            className={'first-interview-date'}
          >
            {selectedFirstInterviewDate?.replace(/-/g, '/') || '（空白）'}
          </div>
          <IcomoonIcon
            name="arrow1s-down"
            css={css`
              color: ${colors.black30};
              font-size: 20px;
            `}
          />
        </button>
        {calendarOpening && (
          <div
            css={css`
              position: absolute;
              z-index: 2;
              margin-top: 7.5px;
              top: 100%;
            `}
          >
            <CompanyFirstInterviewDateCalender
              shortName={shortName}
              firstInterviewDate={
                selectedFirstInterviewDate
                  ? new Date(selectedFirstInterviewDate)
                  : new Date()
              }
              onSelectFirstInterviewDateBlank={(shortName) => {
                setCalendarOpening(false)
                setSelectedFirstInterviewDate(undefined)
                onSelectFirstInterviewDateBlank(shortName, currentUser)
                trackEvent(currentUser, SUM_OF_FIRST_INTERVIEW_DATE_SETTING)
              }}
              onSelectFirstInterviewDate={(
                shortName: string,
                firstInterviewDate: string
              ) => {
                setCalendarOpening(false)
                setSelectedFirstInterviewDate(firstInterviewDate)
                onSelectFirstInterviewDate(
                  shortName,
                  firstInterviewDate,
                  currentUser
                )
                trackEvent(currentUser, SUM_OF_FIRST_INTERVIEW_DATE_SETTING)
              }}
            />
          </div>
        )}
      </div>
    </StatusPanelSection>
  )
}
